function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null);

var _ref3 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 40,
  cy: 40,
  rx: 40,
  ry: 40,
  fill: "#f8cecc",
  stroke: "#b85450",
  pointerEvents: "all"
});

var _ref4 = /*#__PURE__*/React.createElement("text", {
  x: 40,
  y: 44,
  fill: "#000000",
  fontFamily: "Helvetica",
  fontSize: "12px",
  textAnchor: "middle"
}, "Calista");

var _ref5 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 200,
  cy: 40,
  rx: 40,
  ry: 40,
  fill: "#f8cecc",
  stroke: "#b85450",
  pointerEvents: "all"
});

var _ref6 = /*#__PURE__*/React.createElement("text", {
  x: 200,
  y: 44,
  fill: "#000000",
  fontFamily: "Helvetica",
  fontSize: "12px",
  textAnchor: "middle"
}, "Rosie");

var _ref7 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 120,
  cy: 160,
  rx: 40,
  ry: 40,
  fill: "#dae8fc",
  stroke: "#6c8ebf",
  pointerEvents: "all"
});

var _ref8 = /*#__PURE__*/React.createElement("text", {
  x: 120,
  y: 164,
  fill: "#000000",
  fontFamily: "Helvetica",
  fontSize: "12px",
  textAnchor: "middle"
}, "Bennie");

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M 68.53 68.04 L 97.43 119.49",
  fill: "none",
  stroke: "#000000",
  strokeMiterlimit: 10,
  pointerEvents: "stroke"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M 100 124.07 L 93.52 119.68 L 97.43 119.49 L 99.63 116.25 Z",
  fill: "#000000",
  stroke: "#000000",
  strokeMiterlimit: 10,
  pointerEvents: "all"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M 177.87 73.32 L 145.81 121.48",
  fill: "none",
  stroke: "#000000",
  strokeMiterlimit: 10,
  pointerEvents: "stroke"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M 142.9 125.85 L 143.86 118.08 L 145.81 121.48 L 149.69 121.96 Z",
  fill: "#000000",
  stroke: "#000000",
  strokeMiterlimit: 10,
  pointerEvents: "all"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M 80 40 L 160 40",
  fill: "none",
  stroke: "#000000",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeDasharray: "2 6",
  pointerEvents: "stroke"
});

var _ref14 = /*#__PURE__*/React.createElement("text", {
  x: 116,
  y: 24,
  fill: "#000000",
  fontFamily: "Helvetica",
  fontSize: "11px",
  textAnchor: "middle"
}, "?");

var _ref15 = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", {
  requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
}), /*#__PURE__*/React.createElement("a", {
  transform: "translate(0,-5)",
  xlinkHref: "https://desk.draw.io/support/solutions/articles/16000042487",
  target: "_blank"
}, /*#__PURE__*/React.createElement("text", {
  textAnchor: "middle",
  fontSize: "10px",
  x: "50%",
  y: "100%"
}, "Viewer does not support full SVG 1.1")));

var SvgIncompleteTournament = function SvgIncompleteTournament(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "241px",
    height: "202px",
    viewBox: "-0.5 -0.5 241 202",
    content: "<mxfile host=\"app.diagrams.net\" modified=\"2020-08-06T00:05:24.087Z\" agent=\"5.0 (Macintosh; Intel Mac OS X 10_15_5) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/84.0.4147.105 Safari/537.36\" etag=\"4Z3JbBNDuOEtmv83MCcp\" version=\"13.5.9\" type=\"device\"><diagram id=\"Ra3Fi83U9BzJdPZ0KHpK\" name=\"Page-1\">3Vdbb9sgGP01fkyE8SXksU5v0lapWiuteyQ2tlGJyTBpLr9+HzZObCdRm163vSRwgAN85xg+HG8yW10pOs9vZMKEg1GycrxzB+Mx8eDXAOsa8MekBjLFkxpyd8Ad3zALIosueMLKTkctpdB83gVjWRQs1h2MKiWX3W6pFN1Z5zRje8BdTMU++pMnOq9REqAdfs14ljczu8i2zGjT2QJlThO5bEHeheNNlJS6Ls1WEyZM7Jq41OMuj7RuF6ZYoV8y4GYzWZLry2/5/fL2Po02Dxv3amBZnqhY2A07OBTAF6USaGHVem1DEf5eyKZhUFZCnUEHN5yvdo1Qysz/hApeatqQwapqvrrVBmRLjWGlIChUomXONbub09i0LMFSgOV6JqDmQpGW81rllK9YYlbDhZhIIVVF5KUkZnEMeKmVfGStlikJfFCtmfyJKc1WR0PpbgUCYzM5Y1qtoYsdgInV1JraDW192bKIhfKWOxqMWlNmW+adblCw0p0gI/4gGX/IkrP/VETf/8tE9D5IxIgVxReomFBG0oMqhjFh0/R9VPTCropbeb5KxfCAiv0QF8mZuZqgFgtaljzuRpatuH5olX+1yudm36iprG2lnoIle3dZL4ywDLlQMXv+RtBUZUw/59Z9WVphDw6EvcEUE1Tzp+5yD2lhZ7iVvPoEGtVRT3WvJ2e9TTuqfSn2iYIukYd7RHUc9ogqa2y3/Xq3kLe75R21x/+E9i4e+jj0UUhGrjvG41HPCoebT3bGiAz9EPwRjBByiYu8rlE8MhwHoTcOCPYR8vGn2mZ8km0KWZjzPKFlbg7qyjUtAxn8lmrNVFEhGLbanNpNzouPHEtoGHzqwfRlpsNd+TF65YHTzzr2iD7YOc276t2zDMe7fHGKAXb4TqfwUOwmFIJnxoExWINBqhCZxIDDU+zMNsx4khiOSDFYDZ1WfMZlcxOtKn5B5ATngAhDH9H4MVNyUSRN8mG/hKN5h31FWmpn+3Zr+/X4B3k0SRmgoYtI10H+23xpWQZu2B0i07RkJzoHqrtnaN1995b3Lv4A</diagram></mxfile>",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, /*#__PURE__*/React.createElement("g", null, _ref3, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 78,
      height: 1,
      paddingTop: 40,
      marginLeft: 1
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "#000000",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 16
    }
  }, "Calista"))))), _ref4)), _ref5, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 78,
      height: 1,
      paddingTop: 40,
      marginLeft: 161
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "#000000",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 16
    }
  }, "Rosie"))))), _ref6)), _ref7, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 78,
      height: 1,
      paddingTop: 160,
      marginLeft: 81
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "#000000",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 16
    }
  }, "Bennie"))))), _ref8)), _ref9, _ref10, _ref11, _ref12, _ref13, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 20,
      marginLeft: 116
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 11,
      fontFamily: "Helvetica",
      color: "#000000",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 16
    }
  }, "?"))))), _ref14))), _ref15);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIncompleteTournament, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/incomplete-tournament.93604def.svg";
export { ForwardRef as ReactComponent };